import useForceUpdate from './useForceUpdate';


export default useForceUpdate;